<template>
  <div class="user-add-box">
    <div class="sub-contents-box">
      <h1 class="title-header">会員登録</h1>
      <h2 class="">下記項目を入力後、「登録する」ボタンを押してください。</h2>
      <div class="user-info-dls">
        <dl>
          <dt class="c-bg-deep">お名前<span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text" v-model="user_info.name"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">お名前<span class="caption">(ふりがな)</span><span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text" v-model="user_info.f_name"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">郵便番号<span class="red">(必須)</span></dt>
          <dd>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="3" v-model="zip_codes[0]"><span>-</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="zip_codes[1]">
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">都道府県<span class="red">(必須)</span></dt>
          <dd>
            <select v-model="user_info.prefecture">
              <option v-for="(item, index) in prefectures_list" :key="index" :value="item.name">{{item.name}}</option>
            </select>
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">住所１<span class="caption">(市区町村名)</span><span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text long" placeholder="市区町村名" v-model="user_info.address1"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">住所２<span class="caption">(番地・マンション名)</span></dt>
          <dd><input type="text" class="add-text long" placeholder="番地・マンション名" v-model="user_info.address2"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">電話番号<span class="red">(必須)</span></dt>
          <dd>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="3" v-model="tels[0]"><span>-</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="tels[1]"><span>-</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="tels[2]">
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">メールアドレス<span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text" v-model="user_info.mail"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">希望するパスワード<span class="red">(必須)</span></dt>
          <dd><input type="password" class="add-text" v-model="user_info.pass"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">希望するパスワード<span class="caption">(確認用)</span><span class="red">(必須)</span></dt>
          <dd><input type="password" class="add-text" placeholder="確認のため、もう一度入力してください" v-model="user_info.pass2"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">性別</dt>
          <dd>
            <div class="sex-box">
              <input id="sex_1" type="radio" v-model="user_info.sex" value="1">
              <label for="sex_1">男</label>
              <input id="sex_2" type="radio" v-model="user_info.sex" value="2">
              <label for="sex_2">女</label>
            </div>
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">生年月日</dt>
          <dd>(西暦)
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="bdays[0]"><span>年</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="2" v-model="bdays[1]"><span>月</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="2" v-model="bdays[2]"><span>日</span>
          </dd>
        </dl>
      </div>
      <div class="kiyaku">
<b>会員規約</b><br />
<br />
<b>第1条 (会員)</b><br />
1. 「会員」とは、当社が定める手続に従い本規約に同意の上、入会の申し込みを行う個人をいいます。<br />
2. 「会員情報」とは、会員が当社に開示した会員の属性に関する情報および会員の取引に関する履歴等の情報をいいます。<br />
3. 本規約は、すべての会員に適用され、登録手続時および登録後にお守りいただく規約です。<br />
<br />
<b>第2条 (登録)</b><br />
1. 会員資格<br />
&emsp;本規約に同意の上、所定の入会申込みをされたお客様は会員としての資格を有します。会員登録手続は、会員となるご本人が行ってください。代理による登録は一切認められません。なお、過去に会員資格が取り消された方やその他当社が相応しくないと判断した方からの会員申込はお断りする場合があります。<br />
<br />
2. 会員情報の入力<br />
&emsp;会員登録手続の際には、入力上の注意をよく読み、所定の入力フォームに必要事項を正確に入力してください。会員情報の登録において、特殊記号・旧漢字・ローマ数字などはご使用になれません。これらの文字が登録された場合は当社にて変更いたします。<br />
<br />
3. パスワードの管理<br />
(1)パスワードは会員本人のみが利用できるものとし、第三者に譲渡・貸与できないものとします。<br />
(2)パスワードは、他人に知られることがないよう、会員本人が責任をもって管理してください。<br />
(3)パスワードを用いて当社に対して行われた意思表示は、会員本人の意思表示とみなし、そのために生じる支払等はすべて会員の責任となります。<br />
<br />
<b>第3条 (変更)</b><br />
1. 会員は、氏名、住所など当社に届け出た事項に変更があった場合には、速やかに当社に連絡するものとします。<br />
<br />
2. 変更登録がなされなかったことにより生じた損害について、当社は一切責任を負いません。また、変更登録がなされた場合でも、変更登録前にすでに手続がなされた取引は、変更登録前の情報に基づいて行われますのでご注意ください。<br />
<br />
<b>第4条 (退会)</b><br />
&emsp;会員が退会を希望する場合には、会員本人が退会手続きを行ってください。所定の退会手続の終了後に、退会となります。<br />
<br />
<b>第5条 (会員資格の喪失及び賠償義務)</b><br />
1. 会員が、会員資格取得申込の際に虚偽の申告をしたとき、通信販売による代金支払債務を怠ったとき、その他当社が会員として不適当と認める事由があるときは、当社は、会員資格を取り消すことができることとします。<br />
<br />
2. 会員が、以下の各号に定める行為をしたときは、これにより当社が被った損害を賠償する責任を負います。<br />
(1)会員番号、パスワードを不正に使用すること<br />
(2)当ホームページにアクセスして情報を改ざんしたり、当ホームページに有害なコンピュータープログラムを送信するなどして、当社の営業を妨害すること<br />
(3)当社が扱う商品の知的所有権を侵害する行為をすること<br />
(4)その他、この利用規約に反する行為をすること<br />
<br />
<b>第6条 (会員情報の取扱い)</b><br />
1. 当社は、原則として会員情報を会員の事前の同意なく第三者に対して開示することはありません。ただし、次の各号の場合には、会員の事前の同意なく、当社は会員情報その他のお客様情報を開示できるものとします。<br />
(1)法令に基づき開示を求められた場合<br />
(2)当社の権利、利益、名誉等を保護するために必要であると当社が判断した場合<br />
<br />
2. 会員情報につきましては、当社の「個人情報保護への取組み」に従い、当社が管理します。当社は、会員情報を、会員へのサービス提供、サービス内容の向上、サービスの利用促進、およびサービスの健全かつ円滑な運営の確保を図る目的のために、当社おいて利用することができるものとします。<br />
<br />
3. 当社は、会員に対して、情報提供(広告を含みます)を行うことができるものとします。会員が情報提供を希望しない場合は、その旨を通知していただければ情報提供を停止します。ただし、本サービス運営に必要な情報提供につきましては、会員の希望により停止をすることはできません。<br />
<br />
<b>第7条 (禁止事項)</b><br />
&emsp;本サービスの利用に際して、会員に対し次の各号の行為を行うことを禁止します。<br />
(1)法令または本規約、本サービスご利用上のご注意、本サービスでのお買い物上のご注意その他の本規約等に違反すること<br />
(2)当社、およびその他の第三者の権利、利益、名誉等を損ねること<br />
(3)青少年の心身に悪影響を及ぼす恐れがある行為、その他公序良俗に反する行為を行うこと<br />
(4)他の利用者その他の第三者に迷惑となる行為や不快感を抱かせる行為を行うこと<br />
(5)虚偽の情報を入力すること<br />
(6)有害なコンピュータープログラム、メール等を送信または書き込むこと<br />
(7)当社のサーバーその他のコンピューターに不正にアクセスすること<br />
(8)パスワードを第三者に貸与・譲渡すること、または第三者と共用すること<br />
(9)その他当社が不適切と判断すること<br />
<br />
<b>第8条 (サービスの中断・停止等)</b><br />
1. 当社は、本サービスの稼動状態を良好に保つために、次の各号の一に該当する場合、予告なしに、本サービスの提供全てあるいは一部を停止することがあります。<br />
(1)システムの定期保守および緊急保守のために必要な場合<br />
(2)システムに負荷が集中した場合<br />
(3)火災、停電、第三者による妨害行為などによりシステムの運用が困難になった場合<br />
(4)その他、止むを得ずシステムの停止が必要と当社が判断した場合<br />
<br />
<b>第9条 (サービスの変更・廃止)</b><br />
&emsp;当社は、その判断によりサービスの全部または一部を事前の通知なく、適宜変更・廃止できるものとします。<br />
<br />
<b>第10条 (免責)</b><br />
1. 通信回線やコンピューターなどの障害によるシステムの中断・遅滞・中止・データの消失、データへの不正アクセスにより生じた損害、その他当社のサービスに関して会員に生じた損害について、当社は一切責任を負わないものとします。<br />
2. 当社は、当社のウェブページ・サーバー・ドメインなどから送られるメール・コンテンツに、コンピューター・ウィルスなどの有害なものが含まれていないことを保証いたしません。<br />
3. 会員が本規約等に違反したことによって生じた損害については、当社は一切責任を負いません。<br />
<br />
<b>第11条 (本規約の改定)</b><br />
&emsp;当社は、本規約を任意に改定できるものとし、また、当社において本規約を補充する規約(以下「補充規約」といいます)を定めることができます。本規約の改定または補充は、改定後の本規約または補充規約を当社所定のサイトに掲示したときにその効力を生じるものとします。この場合、会員は、改定後の規約および補充規約に従うものといたします。<br />
<br />
<b>第12条 (準拠法、管轄裁判所)</b><br />
&emsp;本規約に関して紛争が生じた場合、当社本店所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。<br />
      </div>
      <input id="kiyaku_chk" type="checkbox" @click="(kiyaku == false) ? kiyaku = true : kiyaku = false">
      <label for="kiyaku_chk">会員規約に同意する</label>
      <div class="flex_between">
        <button class="submit_button" :disabled="kiyaku" @click="user_info_add()">登録する</button>
      </div>
      <div class="back">
        <a @click="cancel">← ログインページに戻る</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAdd',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      user_info: {},
      zip_codes: [],
      tels: [],
      bdays: [],
      kiyaku: true,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    prefectures_list () {return this.$DF.PREFECTURES_LIST;},
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    user_info_add () {
      // 入力確認
      if (this.$lib._emptyChk(this.user_info.mail) === false) {
        this.$alert('alert', 'メールアドレスを入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.pass) === false || this.$lib._emptyChk(this.user_info.pass2) === false) {
        this.$alert('alert', 'パスワードを入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.name) === false) {
        this.$alert('alert', 'お名前を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.f_name) === false) {
        this.$alert('alert', 'お名前(フリガナ)を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.zip_codes[0]) === false || this.$lib._emptyChk(this.zip_codes[1]) === false) {
        this.$alert('alert', '郵便番号を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.prefecture) === false) {
        this.$alert('alert', '都道府県を選択してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.address1) === false) {
        this.$alert('alert', '住所１を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.tels[0]) === false || this.$lib._emptyChk(this.tels[1]) === false || this.$lib._emptyChk(this.tels[2]) === false) {
        this.$alert('alert', '電話番号を入力してください。');
        return;
      }
      if (this.user_info.pass !== this.user_info.pass2) {
        this.$alert('alert', 'パスワードと確認用のパスワードが一致しません。');
        return;
      }
      this.user_info.zip_code = this.zip_codes.join('-');
      this.user_info.telephone = this.tels.join('-');
      this.user_info.birthday = this.bdays.join('-');


      let ld = new this.$loader(this);
      ld._data_set({customers: this.user_info});
      ld._post_cb_f = this.user_info_add_cb;
      ld._load_start('/user/user_add.php');
    },
    user_info_add_cb (data) {
      if (data.res === 1) {
        this.$router.push({name: 'uLogin', query: {type: 'useradd'}});
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    cancel () {
      this.$router.push({name: 'uLogin', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-add-box {
  .sub-contents-box {
    padding-top: 40px;
  }
  h1 {
    width: 240px;
    height: 50px;
    color: #1b2010;
    font-size: 28px;
    letter-spacing: 2px;
    margin: 0px auto 20px auto;
    padding-top: 18px;
    background-image: url('../../assets/login_flower.svg');
    background-repeat: no-repeat;
    -ms-background-position-x: -95px;
  }

  h2 {
    font-size: 16px;
    font-weight: 100;
    color: #5b5845;
    margin: 14px 0 20px 0;
  }
  .user-info-dls {
    width: 690px;
    margin: 0 auto;
  }
  dl {
    display: flex;
    background-color: #fcf3f3;
    border-top: 1px solid #fefefe;
    border-left: 1px solid #fefefe;
    border-right: 1px solid #fefefe;
  }
  dt {
    text-align: left;
    width: 380px;
    color: #5c5945;
    padding: 14px;
    background: #fee2e2;
    border-right: 4px solid #df274c;
  }
  dl:last-child {
    border-bottom: 1px solid #fefefe;
  }
  dd {
    text-align: left;
    font-weight: bold;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    span {
      padding: 0 5px;
    }
    input {
      height: 32px;
      font-size: 18px;
    }
    select {
      width: 100px;
      height: 32px;
    }
  }
  .caption {
    font-size: 12px;
  }
  .add-text {
    margin: 0;
    border-radius: 0px;
  }
  .small {
    width: 60px;
    min-width: 60px;
  }
  .red {
    font-size: 12px;
    color: #df0000;
  }
  .title-header {

  }
  .submit_button {
    width: 300px;
    margin-top: 25px;
    height: 46px;
    color: #fefefe;
    border: initial;
    border-radius: 5px;
    font-size: 16px;
  }
  .back {
    margin-top: 30px;
    a {
      color: #da7d78;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .sex-box {
    padding: 7px 0 0 0;
  }
  .kiyaku {
    width: 670px;
    height: 200px;
    padding: 10px;
    background: #fefefe;
    overflow-y: auto;
    margin: 20px auto;
    text-align: left;
  }
  @media (max-width: 767px) {
    padding: 20px;
    .sub-contents-box {
      padding-top: 30px;
    }
    .user-info-dls {
      width: 100%;
    }
    .kiyaku {
      width: 100%;
      padding: 10px 0;
    }
    dl {
      display: block;
    }
    dt {
      width: auto;
      border-right: 0px;
      border-bottom: 1px solid #dddddd;
    }
  }
}
</style>
